var _require = require('prettier/standalone'),
    _require$doc$builders = _require.doc.builders,
    concat = _require$doc$builders.concat,
    line = _require$doc$builders.line;

var printPreservingEmptyLines = require('./print-preserving-empty-lines');

var SourceUnit = {
  print: function print(_ref) {
    var options = _ref.options,
        path = _ref.path,
        _print = _ref.print;
    return concat([printPreservingEmptyLines(path, 'children', options, _print), line]);
  }
};
module.exports = SourceUnit;